<template>
  <section>
    <modal :title="title" :show="showModal" @close="closeModal()">
      <div class="content" slot="content">
        <div class="flex end actions">
            <div class="button secondary" @click="openModalNew()">
              Adicionar um novo Custo
            </div>
        </div>
        <ul class="margin-top-s">
          <li v-if="false">
            <small>
              Adicione seu primeiro histórico de custo.
            </small>
          </li>
          <li v-for="(m, k) in costHistorysList" :key="k">
            <div class="flex middle">
              <div class="flex-2">
                {{ m.cost | money }}: {{ m.start_date  }} - {{ m.end_date}}
              </div>
              <div class="flex-1 flex end">
                <div class="button secondary" @click="openModalEdit(m)">
                  Editar
                </div>
                <div class="button secondary" @click="openModalDelete(m.id)">
                  Deletar
                </div>
              </div>
            </div>
          </li>
        </ul>

      </div>
      <div class="action" slot="action">
        <div class="flex center">
          <a @click="closeModal()" class="button secondary medium">
            Fechar
          </a>
        </div>
      </div>
    </modal>
    <!-- new list -->
    <new-cost-history
      :show="showEditModal"
      :costHistory="newCostHistory"
      @close="
        showEditModal = false;
        newCostHistory = null;
      "
      @accept="newOrEditHCost($event)"
    ></new-cost-history>
    <!-- modal confirm delete -->
    <modal-confirm
      :show="showDeleteModal"
      description="Você tem certeza que deseja deletar essa lista?"
      @cancel="
        showDeleteModal = false;
        selectModalDelete = null;
      "
      @accept="removeCostHistory(selectModalDelete)"
    ></modal-confirm>
  </section>
</template>

<script>
import { 
  getCostHistorys,
  createCostHistory,
  updateCostHistory,
  removeCostHistory
} from "@/services/costHistory";

import Modal from "@/components/modal/Modal";
import ModalConfirm from "@/components/modal/ModalConfirm";
import NewCostHistory from './NewCostHistory.vue';

const auxNewCostHistory = {
  cost: 0,
  start_date: '',
  end_date: '',
}

export default {
  name: "modal-history-cost",
  props: {
    titleName: {
      required: false,
      default: "Historico de Custos",
    },
    show: {
      required: true,
      default: false,
    },
    unusual: {
      required: false,
      default: "false",
    },
    productId: {
      required: true,
    },
    variantId: {
      required: true,
      default: null,
    }
  },
  components: {
    Modal,
    ModalConfirm,
    NewCostHistory,
  },
  data() {
    return {
      showDeleteModal: false,
      selectModalDelete: null,
      newCostHistory: null,
      showEditModal: false,
      showModal: false,
      seenGuide: {},
      title: "Historico de Custos",
      costHistorysList: [],
    };
  },
  watch: {
    variantId() {
      this.getCostHistorys();
    },
    show(value) {
      this.showModal = value;
    },
  },
  mounted() {
    this.getCostHistorys();
  },
  computed: {
  },
  methods: {
    newOrEditHCost(auxNewCost) {
      this.showEditModal = false
      this.newCostHistory = null

      if (auxNewCost.id) {
        return this.updateCostHistory(auxNewCost)
      } 

      return this.createCostHistory(auxNewCost)
    },
    openModalEdit(listAux) {
      this.showEditModal = true
      this.newCostHistory = listAux
    },
    openModalNew() {
      this.showEditModal = true
      this.newCostHistory = Object.assign({}, auxNewCostHistory)
    },
    openModalDelete(listId) {
      this.showDeleteModal = true
      this.selectModalDelete = listId
    },
    getCostHistorys() {
      let params = {
        product_variant_id: this.variantId
      }

      getCostHistorys(this.productId, params)
        .then((result) => {
          this.costHistorysList = result;
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "falha ao buscar custos",
          });
        });
    },
    createCostHistory(historyCost) {
      let params = {
        product_variant_id: this.variantId
      }

      params = Object.assign(params, historyCost)

      createCostHistory(this.productId, params)
        .then((result) => {
          this.costHistorysList.push(result);
          this.$toast.success({
            title: "Sucesso",
            message: "Custo criada com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao criar Custo",
          });
        });
    },
    updateCostHistory(historyCost) {
      let params = {
        product_variant_id: this.variantId
      }
      
      params = Object.assign(params, historyCost)

      updateCostHistory(this.productId, historyCost.id, params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Custo editada com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao editar custo",
          });
        });
    },
    removeCostHistory(hc_id) {
      removeCostHistory(this.productId, hc_id)
        .then(() => {

          this.costHistorysList = this.costHistorysList.filter(l => l.id != hc_id)
          this.$toast.success({
            title: "Sucesso",
            message: "Custo removida com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao remover lista",
          });
        })
        .finally(() => {
          this.showDeleteModal = false
          this.selectModalDelete = null
        })
    },
    acceptModal() {
      this.showModal = false;
      this.$emit("accept", this.tag);
    },
    closeModal() {
      this.showModal = false;
      this.$emit("close", false);
    },
  },
};
</script>

<style lang="scss" scoped>


.action {
  margin-top: 30px;
  .button {
    margin-left: 10px !important;
  }
}

textarea {
  border-radius: 5px;
  border: 1px solid #3333;
  padding: 15px;
  max-width: 500px;
  min-width: 500px;
  min-height: 150px;
  max-height: 150px;
}

ul {
  list-style: none;
  max-height: 350px;
  overflow-y: scroll;
  li {
    padding: 4px 8px;
    border-bottom: 1px solid #ccc;
    .tag {
      background: #c2c2c2;
      padding: 4px 6px;
      border-radius: 5px;
      font-size: 11px;
      font-weight: 800;
      margin-left: 8px;
    }
    .button {
      margin-left: 4px;
      padding: 4px 6px;
    }
  }
}
</style>
